
const WeeklySalesCard = () => {
    return (
        <div className="card card-flush py-4">
            <div className="card-header">
                <div className="card-title">
                    <h2>Weekly Sales</h2>
                </div>
            </div>

            <div className="card-body pt-0">
                <span className="text-muted">No data available. Sales data will begin capturing once product has been published.</span>
            </div>
        </div>
    )
}

export default WeeklySalesCard;